export default "__VITE_ASSET__bfN2bHSh__"